var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"85%"},attrs:{"id":"pie_ring"}})
}
var staticRenderFns = []

export { render, staticRenderFns }